import React, { useEffect, useState } from 'react';
import { UsersRound, RefreshCw } from 'lucide-react';

const API = process.env.REACT_APP_API_URL || '/api';
const entete = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

function IaClients({ currentUser }) {
  const estAdmin = currentUser && (currentUser.role === 'admin' || currentUser.role === 'sous_admin');
  const [ssoUrl, setSsoUrl] = useState(null);
  const [ssoErr, setSsoErr] = useState(false);
  const [clients, setClients] = useState([]);
  const [chargement, setChargement] = useState(true);
  const [q, setQ] = useState('');

  const chargerSso = async () => {
    setChargement(true); setSsoErr(false);
    try {
      const r = await fetch(`${API}/ia-admin-sso`, { headers: entete() });
      const j = await r.json();
      if (j && j.url) setSsoUrl(j.url + '&_=' + Date.now()); else setSsoErr(true);
    } catch (e) { setSsoErr(true); }
    setChargement(false);
  };
  const chargerTable = async () => {
    setChargement(true);
    try {
      const r = await fetch(`${API}/ia-clients`, { headers: entete() });
      const j = await r.json();
      setClients(Array.isArray(j.clients) ? j.clients : []);
    } catch (e) { setClients([]); }
    setChargement(false);
  };
  useEffect(() => { if (estAdmin) chargerSso(); else chargerTable(); /* eslint-disable-next-line */ }, []);

  const dt = (s) => { if (!s) return '—'; try { return new Date(s).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: '2-digit' }); } catch (e) { return '—'; } };

  if (estAdmin) {
    return (
      <div style={{ background: '#f1f5f9', minHeight: 'calc(100vh - 150px)', padding: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 20px', background: '#fff', borderBottom: '1px solid #e2e8f0' }}>
          <h2 style={{ display: 'flex', alignItems: 'center', gap: 9, margin: 0, color: '#0f172a', fontSize: 20 }}><UsersRound size={22} color="#6366f1" /> Clients IA Shops</h2>
          <button onClick={chargerSso} style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 6, border: '1px solid #e2e8f0', background: '#fff', color: '#334155', borderRadius: 8, padding: '8px 14px', cursor: 'pointer', fontWeight: 600 }}><RefreshCw size={15} /> Rafraîchir</button>
        </div>
        {chargement ? <p style={{ color: '#64748b', padding: 20 }}>Chargement…</p> : ssoErr ? <p style={{ color: '#b91c1c', padding: 20 }}>Connexion à ia.e-application.fr indisponible. Cliquez sur Rafraîchir pour réessayer.</p> : (
          <iframe title="Clients IA Shops" src={ssoUrl} style={{ width: '100%', height: 'calc(100vh - 215px)', border: 0, background: '#f6f7fb' }} />
        )}
      </div>
    );
  }

  const filtres = clients.filter((c) => !q || (c.email || '').toLowerCase().includes(q.toLowerCase()) || (c.nom || '').toLowerCase().includes(q.toLowerCase()) || (c.code || '').toLowerCase().includes(q.toLowerCase()));
  return (
    <div style={{ background: '#f1f5f9', minHeight: 'calc(100vh - 150px)', padding: 20 }}>
     <div style={{ background: '#fff', borderRadius: 14, boxShadow: '0 1px 4px rgba(15,23,42,.08)', padding: '22px 26px', maxWidth: 1200, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginBottom: 6 }}>
        <h2 style={{ display: 'flex', alignItems: 'center', gap: 9, margin: 0, color: '#0f172a', fontSize: 22 }}><UsersRound size={24} color="#6366f1" /> Clients IA Shops</h2>
        <span style={{ background: '#eef2ff', color: '#4338ca', fontWeight: 700, fontSize: 13, padding: '3px 11px', borderRadius: 999 }}>{filtres.length} client{filtres.length > 1 ? 's' : ''} (les vôtres)</span>
        <button onClick={chargerTable} style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 6, border: '1px solid #e2e8f0', background: '#fff', color: '#334155', borderRadius: 8, padding: '8px 14px', cursor: 'pointer', fontWeight: 600 }}><RefreshCw size={15} /> Rafraîchir</button>
      </div>
      <p style={{ color: '#64748b', marginTop: 0, marginBottom: 16, fontSize: 13.5 }}>Vos clients : ceux qui se sont inscrits avec votre code.</p>
      <input placeholder="Rechercher (nom, e-mail, code)…" value={q} onChange={(e) => setQ(e.target.value)} style={{ width: '100%', maxWidth: 360, padding: '10px 13px', border: '1px solid #e2e8f0', borderRadius: 9, marginBottom: 16, fontSize: 14 }} />
      {chargement ? <p style={{ color: '#64748b' }}>Chargement…</p> : (
        filtres.length === 0 ? <p style={{ color: '#64748b' }}>Aucun client pour le moment.</p> : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
              <thead>
                <tr style={{ textAlign: 'left', borderBottom: '2px solid #e2e8f0', color: '#475569' }}>
                  <th style={{ padding: '10px 8px' }}>Client</th>
                  <th style={{ padding: '10px 8px' }}>E-mail</th>
                  <th style={{ padding: '10px 8px' }}>Code</th>
                  <th style={{ padding: '10px 8px' }}>Réduction</th>
                  <th style={{ padding: '10px 8px' }}>Inscrit le</th>
                </tr>
              </thead>
              <tbody>
                {filtres.map((c) => (
                  <tr key={c.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                    <td style={{ padding: '9px 8px', fontWeight: 600 }}>{c.nom || '—'}</td>
                    <td style={{ padding: '9px 8px', color: '#475569' }}>{c.email}</td>
                    <td style={{ padding: '9px 8px' }}>{c.code ? <span style={{ background: '#ede9fe', color: '#6d28d9', fontWeight: 700, padding: '2px 8px', borderRadius: 999, fontSize: 12 }}>{c.code}</span> : <span style={{ color: '#94a3b8' }}>—</span>}</td>
                    <td style={{ padding: '9px 8px' }}>{c.reduction_pct ? c.reduction_pct + '%' : '—'}</td>
                    <td style={{ padding: '9px 8px', color: '#64748b' }}>{dt(c.cree_le)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}
     </div>
    </div>
  );
}

export default IaClients;
